<template>
  <v-container fluid grid-list-md py1>
    <v-layout row wrap>
      <v-flex md4>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.seguridad.perfil.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <!-- Clave -->
                  <v-text-field v-if="perfil.clave" v-model="perfil.clave" :label="$t('view.commons.clave')" disabled />

                  <!-- Group Name -->
                  <v-text-field
                    v-model.trim="$v.perfil.nombre.$model"
                    :error-messages="getFirstErrorDescription($v.perfil.nombre)"
                    :label="$t('view.seguridad.perfil.form.nombre.label')"
                    :disabled="view.action.submit.busy" />

                  <!-- Descripcion -->
                  <v-text-field
                    v-model.trim="$v.perfil.descripcion.$model"
                    :error-messages="getFirstErrorDescription($v.perfil.descripcion)"
                    :label="$t('view.seguridad.perfil.form.descripcion.label')"
                    :disabled="view.action.submit.busy" />
                </form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-show="perfil.clave && $userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.privileges')"
                    :loading="view.action.submit.busy"
                    @click="loadPrivileges($v.perfil.clave.$model, $v.perfil.nombre.$model)">
                    <v-icon small>fas fa-lock</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="perfil.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="$userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>

      <v-flex md8>
        <data-table ref="perfilTable" @editRow="load" @auditRow="audit" @clearRow="form.$state.clear()" @showPrivileges="loadPrivileges" />
      </v-flex>
    </v-layout>

    <auditoria ref="auditModal" />

    <privilegiosModal ref="PrivilegiosModal" />
  </v-container>
</template>
<script>
import perfilStates from "@/views/seguridad/perfil/perfil-state"; /** *******************************/
import perfilAPI from "@/services/seguridad/perfil"; /** *******************************/
import DataTable from "@/views/seguridad/perfil/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import PrivilegiosModal from "@/views/seguridad/perfil/PrivilegiosModal"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required, maxLength } from "vuelidate/lib/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { submit } from "@/constants/buttons";
import tippy from "tippy.js";

const action = { submit: { busy: false } };

export default {
  name: "PerfilModule"
  , components: {
    DataTable
    , Auditoria
    , PrivilegiosModal
  }
  , data() {
    return {
      perfil: undefined
      , form: new Object()
      , search: ""
      , view: {
        title: this.$t("view.seguridad.perfil.title")
        , action
        , elem: {
          button: { submit }
          , showForm: true
        }
      }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.form = new perfilStates(this);
    this.form.$setState("initial");
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.perfil);
        handleResponse(respuesta, this.$t("view.seguridad.perfil.errors"));
      } catch (error) {
        handleResponse(error, this.$t("view.seguridad.perfil.errors"));
      }
    }
    , async load(clave) {
      try {
        const response = await perfilAPI.get(clave);
        const { data: { results: { perfil } } } = response;
        this.form.$setState("editing", perfil);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.perfil.clave, dataDescripcion = this.perfil.descripcion) {
      this.$refs.auditModal.loadAudit(clave, "Groups", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
    , async loadPrivileges(clave, nombrePerfil) {
      this.$refs.PrivilegiosModal.loadPrivileges(clave, nombrePerfil);
    }
  }
  , validations: {
    perfil: {
      nombre: {
        required
        , maxLength: maxLength(50)
      }
      , descripcion: {
        required
        , maxLength: maxLength(250)
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/seguridad/perfil/Perfil.vue